@import '~style-sheet-helpers/core.less';
@import (reference) '../../../constants/spacing.module.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.popover-target {
  display: flex;

  &.clickable:hover {
    cursor: pointer;
  }
}

.popover-container {
  border: var(--grey-300) 1px solid;
  border-radius: 4px;

  background: @interactive-popover--flyout--background-color;
  color: @interactive-popover--flyout--text-color;

  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  &.dark {
    border: none;

    background: var(--grey-900);
    color: var(--white);
    border-radius: 4px;
  }
}

.popover-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: @space-16;
  padding: @space-12;
  min-width: 150px;

  background-color: var(--grey-200);
  border-bottom: 1px solid var(--grey-300);
  border-radius: 3px 3px 0 0;
}

.popover-content {
  padding: @space-12;
  max-width: 300px;
  width: 100%;
  max-height: 300px;

  &.tooltip-popover {
    font-size: 12px;
    padding-top: 10px;
  }
}

.flyout-popover {
  z-index: 9999999;
}

.popover-title {
  color: @interactive-popover--title--text-color;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  white-space: nowrap;
}

.popover-close-button {
  height: 24px;
  width: 24px;
  cursor: pointer;
  border-radius: 4px;

  > svg {
    width: 12px;
    height: 12px;
    fill: var(--grey-500);
  }

  &:hover {
    background-color: var(--grey-300);
    fill: var(--grey-600);
  }
}

.see-full-msg {
  text-decoration: none;
  font-style: italic;
  padding-top: 6px;
}

.see-full-msg-dark {
  color: var(--white);
  font-style: normal;
}

.date {
  padding-left: 5px;
}
